const brand = sessionStorage.getItem('brand');
export const settings = {
  myAccount: 'Mitt konto',
  yourProfileAndPasswordSecurity: 'Din profil och lösenordssäkerhet',
  detailsHeader: 'Detaljer',
  passwordHeader: 'Lösenord',
  customAttributeHeader: 'Anpassad attribut',
  tagsHeader: 'Taggar',
  accessTokenHeader: 'Access Token',
  thirdPartyIntegrationsHeader: 'Tredjepartsintegrationer',
  appTooltip: {
    TOOLTIP_DETAILS_HEADING: 'Uppdatera ditt kontoprofil',
    TOOLTIP_PASSWORD_HEADING: 'Ändra ditt lösenord',
    TOOLTIP_TAGS_HEADING: 'Hantera dina taggar',
    TOOLTIP_THIRD_PARTY_HEADING: 'Tredjepartsintegrationer',
    TOOLTIP_CHANGE_PASSWORD_TITLE: `Ett säkert lösenord hjälper till att skydda ditt ${brand}-konto`,
    TOOLTIP_INTEGRATIONS: 'Integrera',
    TOOLTIP_ADD_UPDATE_CUSTOM_ATTRIBUTE:
      'Lägg till eller uppdatera anpassade attribut',
    TOOLTIP_CUSTOM_ATTRIBUTES: 'Hantera dina anpassade attribut',
  },
  accessToken: {
    accessToken: 'Access Token',
    generateYourAccessTokenForUsingPlatformAPIs: `Generera din åtkomsttoken för att använda plattformens API:er`,
    generateApiToken: 'Generera API-token',
    revokeApiToken: 'Upphäv API-token',
    regenerateApiToken: 'Regenerera API-token',
    placeholders: {
      yourApiKey: 'Ditt API-nyckel',
    },
  },
  details: {
    name: 'Namn',
    emailId: 'E-postadress ',
    yourPlan: 'Ditt plan',
    messagesPerMonth: ' meddelanden/månad',
    daysOfStoragePlan: ' dagar lagringsplan',
    conditionalFeatures: 'betingade funktioner',
    upgradeToEnterprisePlanToGetMore:
      'Uppgradera till Enterprise-planen för att få mer',
    featuresAndStorageCapacity: 'funktion och lagringskapacitet',
    upgradePlan: 'Uppgradera planen',
    submit: 'Skicka in',
    selectLanguage: 'Välj språk',
    baby: 'Baby',
    king: 'Kung',
    conversationsperMonth: 'konversationer/månad',
    english: 'Engelska',
    hindi: 'Hindi',
    german: 'Tyska',
    french: 'Franska',
    portuguese: 'Portugisiska',
    spanish: 'Spanska',
    italian: 'Italienska',
    russian: 'Ryska',
    chatBotBrandName: 'Varumärkesnamn för chattbot',
    placeholders: {
      john: 'John',
      email: 'E-post',
      searchLanguage: 'Sök språk',
      chatBotBrandName: 'Varumärkesnamn för chattbot',
      brandWebsiteUrl: 'www.yourbrand.com',
      agencyName: 'Lookup Technologies',
      phoneNumber: '9876543210',
      agencySupportEmail: 'support@yourbrand.com',
      agencyContactPersonName: 'Kevin Peterson',
      agencyContactPersonEmailId: 'kevin@yourbrand.com',
    },
    appTooltip: {
      TOOLTIP_NAME: 'Ange ditt profilnamn',
      TOOLTIP_EMAIL_ADDRESS: 'Ange din e-postadress',
    },
    changeEmail: {
      changeLabel: 'Ändra',
      sendVerificationCodeModal: {
        changeEmail: 'Ändra e-post',
        changeEmailDescription:
          'Ange din nya e-postadress som du vill använda i framtiden',
        newEmailLabel: 'Ny e-postadress',
        changeEmailPlaceholder: 'Ange ny e-post',
        sendVerificationCode: 'Skicka verifieringskod',
      },
      verifyEmailModal: {
        verifyEmail: 'Verifiera e-post!',
        verifyDescription:
          'Vi har skickat verifieringskoden till din registrerade befintliga e-post.',
        checkSpam: 'Fick du inget e-postmeddelande? Kolla din skräppostmapp',
        labelText: 'Ange 4-siffrig kod',
        submitText: 'Skicka in',
        resendText: 'Skicka igen kod',
      },
    },
    myAccountDetails: {
      brandDetails: 'Varumärkesdetaljer',
      brandName: 'Varumärkesnamn',
      brandWebsiteUrl: 'Varumärkets webbplats-URL',
      brandLogo: 'Varumärkeslogotyp',
      agencyDetails: 'Byrådetaljer',
      agencyName: 'Byrånamn',
      agencyPhoneNumber: 'Byrå telefonnummer',
      agencyEmailId: 'Byrå e-post-id',
      contactPersonDetails: 'Kontaktpersonsdetaljer',
      contactName: 'Kontaktnamn',
      phoneNumber: 'Telefonnummer',
      contactEmailId: 'E-postadress',
      updateDetails: 'Uppdatera detaljer',
    },
  },
  customAttribute: {
    addAttribute: 'Lägg till attribut',
    discard: 'Förkasta',
    customAttribute: 'Anpassade attribut',
    checkOrAddCustomAttribute:
      'Här kan du kontrollera och lägga till dina anpassade attribut.',
    attributeKey: 'Attributnyckel',
    attributeName: 'Attributnamn',
    bot: 'Bot',
    flow: 'Flöde',
    loadMore: 'Ladda mer',
    question: 'Fråga',
    action: 'Åtgärd',
    search: 'Sök',
    selectBot: 'Välj Bot',
    selectFlow: 'Välj Flöde',
    selectQuestion: 'Välj Fråga',
    noDataFoundHeading: 'Du har inga attribut skapade ännu',
    noDataFoundSubheading: 'Alla dina attribut kommer att visas här',
    deleteTitle: 'Ta bort attribut',
    deleteDescription: 'Är du säker på att du vill ta bort detta attribut?',
    deleteAttributes: 'Ta bort attribut',
    areYouSureYouWantToDeleteThisAttributes:
      'Är du säker på att du vill ta bort dessa attribut?',
    editAttribute: 'Redigera attribut',
    headsUp: 'Heads Up',
    okay: 'Okej',
    dataAddedToLead:
      'Attributen kopplade till dina API:er eller Bot Flöden kommer inte att uppdateras. ' +
      'Uppdatera API:erna eller Bot Flödena enligt behov.',
    placeholders: {
      enterAttributeKey: 'Ange attributnyckel',
      enterAttributeName: 'Ange attributnamn',
      selectBot: 'Välj Bot',
      selectFlow: 'Välj Flöde',
      selectQuestion: 'Välj Fråga',
      search: 'Sök efter attributnamn',
    },
    appToolTip: {
      TOOLTIP_ATTRIBUTE_KEY: 'Ange attributnyckel',
      TOOLTIP_ATTRIBUTE_NAME: 'Ange attributnamn',
      TOOLTIP_SELECT_BOT: 'Välj Bot',
      TOOLTIP_SELECT_FLOW: 'Välj Flöde',
      TOOLTIP_SELECT_QUESTION: 'Välj Fråga',
    },
  },
  password: {
    changePassword: 'Ändra lösenord',
    aSecurePasswordHelpsProtectYour:
      'Ett säkert lösenord hjälper till att skydda din ',
    account: ' Konto',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    cancel: 'Avbryt',
    updatePassword: 'Uppdatera lösenord',
    deleteAccount: 'Ta bort konto',
    placeholders: {
      enterYourCurrentPassword: 'Ange ditt nuvarande lösenord',
      enterYourNewPassword: 'Ange ditt nya lösenord',
      enterYourConfirmPassword: 'Ange ditt bekräftade lösenord',
    },
    appTooltip: {
      TOOLTIP_CURRENT_PASSWORD: 'Ange det gamla lösenordet',
      TOOLTIP_NEW_PASSWORD: 'Ange det nya lösenordet',
      TOOLTIP_CONFIRM_PASSWORD: 'Bekräfta ditt nya lösenord',
      TOOLTIP_DELETE_ACCOUNT: `Ta bort ditt nuvarande ${brand}-konto`,
    },
  },
  tags: {
    manageTags: 'Hantera taggar',
    createNewTags: 'Skapa nya taggar',
    createNewTagsSubText:
      'Hantera dina taggar här för att använda dem för att bättre organisera dina leads, chattar, grupper etc',
    tagName: 'Taggnamn',
    updateTag: 'Uppdatera tagg',
    createTag: 'Skapa tagg',
    discard: 'Förkasta',
    searchTag: 'Sök efter taggnamn',
    noTagFound: 'Ingen tagg hittades!',
    createATag: 'Skapa en tagg',
    deleteTagModalSubText:
      'Är du säker på att du vill ta bort denna tagg? Att ta bort denna tagg tar också bort den från de tilldelade användarna!',
    deleteTagModalHeading: 'Ta bort taggar',
    deleteOneTagModalHeading: 'Ta bort tagg',
    actions: 'Åtgärder',
    placeholders: {
      enterTag: 'Ange taggnamn',
    },
    appTooltip: {
      TOOLTIP_DELETE_TAGS: 'Ta bort taggar',
      TOOLTIP_MANAGE_TAGS: 'Hantera dina taggar',
    },
  },
  thirdPartyIntegration: {
    list: {
      name: 'Namn',
      status: 'Status',
      action: 'Åtgärd',
      messageBird: 'MessageBird',
      messageBirdForSendingMessagesAndEmails:
        'MessageBird för att skicka meddelanden och e-post',
      notConnected: 'Ej ansluten',
      connected: 'Ansluten',
      edit: 'Redigera',
      plivo: 'Plivo',
      plivoForSendingMessages: 'Plivo för att skicka meddelanden',
      connect: 'Anslut',
      appTooltip: {
        nameOfAppOrCrm: 'Namn på App/CRM',
        statusAsConnectedOrNotConnected: 'Status som ansluten/inte ansluten',
        clickToConnectAppOrCrm: 'Klicka för att ansluta App/CRM',
      },
      upgradeModal: {
        oopsIntegrationsAreNotAvailableForBabyPlan:
          'Hoppsan! Integrationer är inte tillgängliga i Baby-planen. Var god uppgradera till King-planen för integrationer.',
      },
    },
    providers: {
      messageBird: {
        messageBird: 'MessageBird',
        integrateWithMessageBird: 'Integrera med MessageBird',
        apiKey: 'API-nyckel',
        originator: 'Ursprung',
        connect: 'Anslut',
        disconnect: 'Koppla från',
        seeActivities: 'Se aktiviteter',
        sms: 'SMS ',
        time: 'Tid',
        phoneNumber: 'Telefonnummer',
        status: 'Status',
        botName: 'Botnamn',
        message: 'Meddelande',
        error: 'Fel',
        placeholders: {
          apiKey: 'API-nyckel',
          messageBirdPhoneNumber: 'MessageBird-telefonnummer',
        },
        noDataFound: {
          activities: 'Aktiviteter',
          noActivitiesFound: 'Inga aktiviteter hittades!',
        },
      },
      plivo: {
        plivo: 'Plivo',
        integrateWithPlivo: 'Integrera med Plivo',
        authId: 'Auth ID',
        authToken: 'Auth Token',
        yourPlivoPhoneNumber: 'Ditt Plivo-telefonnummer',
        connect: 'Anslut',
        disconnect: 'Koppla från',
        seeActivities: 'Se aktiviteter',
        sms: 'SMS',
        time: 'Tid',
        phoneNumber: 'Telefonnummer',
        status: 'Status',
        botName: 'Botnamn',
        message: 'Meddelande',
        error: 'Fel',
        noDataFound: {
          activities: 'Aktiviteter',
          noActivitiesFound: 'Inga aktiviteter hittades!',
        },
        placeholders: {
          authId: 'Auth ID',
          authToken: 'Auth Token',
          yourPlivoPhoneNumber: 'Ditt Plivo-telefonnummer',
        },
      },
    },
  },
};
